import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import CopyRight from "../CopyRight";
import { loginHandleChange } from "../../common/actions";
import { loginAction } from "../../Containers/Login/actions";

import logo from "../../images/clean-your-lists-transparent-logo.png";
import help from "../../images/help.svg";
import "../../css/animate.min.css";

import Overlay from "../../utility/overlay";

import {
  loginValidators,
  updateValidators,
  initValidations,
} from "../../utility/validations";

import { ValidationSummary } from "../../utility/ValidationSummary";
import { GOOGLE_TAG_CODE, SCRIPT_URL } from "../../common/constants";
import "../../App.css";
import FormInput from "../Forms/Input";
import FormSubmit from "../Forms/Submit";
import leftPanelIcon from "../../images/login-screen.png";
import { PASSWORD_MAX_LEN } from "../../utility/globalConstants";
const mapStateToProps = (state) => ({
  loginInfo: state.loginInfo,
});

class LoginForm extends Component {
  constructor(props) {
    super(props);

    this.state = { showErrorSummary: false };

    this.validators = loginValidators;
    initValidations(this.validators);

    this._handleChange = this._handleChange.bind(this);
    this._handleSubmit = this._handleSubmit.bind(this);
  }
  _handleChange(event) {
    this.props.dispatch(
      loginHandleChange(event.target.name, event.target.value)
    );
    updateValidators(this.validators, event.target.name, event.target.value);
  }
  _handleSubmit(event) {
    event.preventDefault();
    this.setState({ showErrorSummary: true });
    if (this.validators.errorSummary.length == 0) {
      const { username, password } = this.props.loginInfo;
      this.props.dispatch(loginAction({ username, password }));
    } else {
      console.log("form is Invalid");
    }
  }
  componentDidMount() {
    let e, t;
    e = document.createElement("script");
    e.type = "text/javascript";
    e.id = "tracker-script";
    e.async = !0;
    e.defer = !0;
    e.src = SCRIPT_URL;
    t = document.getElementsByTagName("head")[0];
    t.prepend(e);
    if (GOOGLE_TAG_CODE) {
      window["dataLayer"] = [];
      window["dataLayer"].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });
      var firstScriptTag = document.getElementsByTagName("script")[0];
      var scriptTag = document.createElement("script");
      scriptTag.async = true;
      scriptTag.id = "gtm-script";
      scriptTag.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_CODE}`;
      firstScriptTag.parentNode.insertBefore(scriptTag, firstScriptTag);
      let body = document.getElementsByTagName("body");
      body = body[0];
      body.insertAdjacentHTML(
        "afterbegin",
        "<noscript id='n-script'></noscript>"
      );
      let iFrame = document.createElement("iframe");
      iFrame.src = `https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_CODE}`;
      iFrame.style.cssText = "height=0;width=0;display:none;visibility:hidden";
      document.getElementById("n-script").appendChild(iFrame);
      document.body.classList.add("bgColor");
    }
  }
  componentWillUnmount() {
    var element = document.getElementById("tracker-script");
    element.parentNode.removeChild(element);
    var element1 = document.getElementById("gtm-script");
    element1.parentNode.removeChild(element1);
    const element2 = document.getElementById("n-script");
    element2.parentNode.removeChild(element2);
    document.body.classList.remove("bgColor");
  }

  render() {
    // const { redirect } = this.state;
    const { username, password } = this.props.loginInfo;

    // console.log(
    //   `this.props.loginFormDisabled  values is =  ${
    //     this.props.loginInfo.btnDisabled
    //   }`
    // );

    return (
      <div className="signup-container">
        {this.state.showErrorSummary ? (
          <ValidationSummary errorMsg={this.validators.errorSummary} />
        ) : null}
        {this.props.loginInfo.btnDisabled ? <Overlay /> : null}
        <div className="login-image"></div>
        <div className="section-form">
          <form className="login-frm" onSubmit={this._handleSubmit}>
            <div style={{ textAlign: "center", marginTop: 40 }}>
              <h1>
                <a
                  href="https://cleanyourlists.com/"
                  target="_blank"
                >
                  <img src={logo} alt="logo" width="320" />
                </a>
              </h1>
              <p style={{ fontSize: 35, paddingTop: 65, marginBottom: 0 }}>
                <b>Members Login</b>
              </p>
              <p style={{ fontSize: 15 }}>
                Don't have account?&nbsp;
                <Link to="/signup"
                  style={{ textDecoration: "underline", color: "#52a792" }}
                >
                  Signup
                </Link>
              </p>
              <FormInput
                type={"email"}
                placeholder="Email *"
                onChange={this._handleChange}
                value={this.props.username}
                styles={{ marginBottom: 20, width: "80%" }}
                name="username"
              />
              <FormInput
                type="password"
                placeholder="Password *"
                onChange={this._handleChange}
                value={this.props.password}
                styles={{ marginBottom: 2, width: "80%" }}
                name="password"
                maxLength={PASSWORD_MAX_LEN}
              />
              <div style={{
                display: "flex",
                flexDirection:"row-reverse",
                width:"80%",
                margin: "0 auto 10px"
              }}>
                <span>
                  <Link
                    style={{ fontSize: 16, color: "#52a792" }}
                    to="/forgotpassword"
                  >
                    Forgot your password?
                  </Link>
                </span>
              </div>
              <FormSubmit
                value="Submit"
                styles={{
                  marginTop: 5,
                  marginBottom: 10,
                  color: "#fff",
                  width: "80%",
                  background: "#272759",
                }}
              />
              <p className="signupTerms">
                <Link
                  style={{ fontSize: 16, color: "#52a792" }}
                  to="/resendactivation"
                >
                  Resend Activation
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

LoginForm.propTypes = {
  loginInfo: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  dispatch: PropTypes.func,
  history: PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/components/Login/LoginForm.js